<template>
	<section class="ui-tag-icon" :style="[textSizeCss, borderCss]">
		
		<i :class="icon" v-if="icon" :style="[iconColorCss, iconSizeCss]"></i>
		<a :href="url" target="_blank" v-if="url">
			<span :style="[colorCss, textDecorationCss]">{{ text }}</span>
		</a>
		<span v-if="!url" :class="{ 'hover': hasHover }" :style="[colorCss, textDecorationCss]">{{ text }}</span>
	</section>
</template>

<script>
	export default {
		name: "ui-tag-icon",
		components: {},
		props: {
			/**
			 * Utilize para aplicar texto na tag
			 */
			text: {
				required: false,
			},
			/**
			 * Utilize para aplicar um icone no botão
			 */
			icon: {
				required: true,
			},
			/**
			 * Utilize para alterar o tamanho do icone
			 */
			iconSize: {
				required: false,
				default: 16,
			},
			/**
			 * Utilize para alterar o tamanho do texto
			 */
			textSize: {
				required: false,
				default: 12,
			},
			/**
			 * Utilize para alterar o tamanho da borda
			 */
			border: {
				required: false,
				default: 1,
			},
			/**
			 * Utilize para alterar a cor do texto
			 */
			color: {
				required: false,
				default: "",
			},
			/**
			 * Utilize para alterar a cor do texto
			 */
			iconColor: {
				required: false,
				default: "",
			},
			/**
			 * Utilize ativar o hover do elemento
			 */
			hasHover: {
				required: false,
				default: false,
			},
			/**
			 * Utilize ativar o hover do elemento
			 */
			textDecoration: {
				required: false,
			},
			/**
			 * Utilize para criar links
			 */
			url: {
				required: false,
			},
		},
		data() {
			return {
				colorCss: {
					color: this.color,
				},
				textDecorationCss: {
					textDecoration: this.textDecoration,
				},
				
				iconSizeCss: {
					fontSize: this.iconSize + "px",
				},
				textSizeCss: {
					fontSize: this.textSize + "px",
					lineHeight: this.textSize + "px",
				},
				borderCss: {
					borderWidth: this.border + "px",
					borderColor: "#d5e0ec",
					borderStyle: "solid",
				},
			}
		},

		computed: {
			/** Computed property que retorna o CSS para a cor do ícone */
			iconColorCss() {
				return { color: this.iconColor }
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
